import { css } from '@emotion/react';
import * as React from 'react';

type FormLayoutProps = {
  submitButton: React.ReactNode;
  shrinkLayout?: boolean;
};

export const FormLayout: React.FC<React.PropsWithChildren<FormLayoutProps>> = ({
  submitButton,
  shrinkLayout,
  children,
}) => {
  return (
    <div css={styles.wrapper}>
      <div css={styles.childrenWrapper(shrinkLayout)}>{children}</div>
      {submitButton}
    </div>
  );
};

const styles = {
  wrapper: css({ display: 'flex', flexDirection: 'column', height: '100%' }),
  childrenWrapper: (shrink?: boolean) => ({
    ...(!shrink && {
      overflow: 'auto',
      flexGrow: 1,
    }),
  }),
};
